import type {ByodFilterMap} from 'src/types/byod';

import {convertStructuredFiltersForWire} from './structured-filters';
import {projectInjectedFilters} from './project-injected-filters';

/**
 * Resolve the final `/query` `widget_filters` map for a tile — the ONE read-path
 * filter transform shared by the builder canvas and the embeddable view:
 *
 *  1. the tile's SAVED `widget_filters_json`, converted to the backend wire shape
 *     (`convertStructuredFiltersForWire`) — structured workflow-node/entity
 *     values persist a rich shape the `/query` endpoint can't read, so they're
 *     converted here (never on the already-wire injected filters, which the
 *     converter is NOT idempotent for);
 *  2. the canvas-injected filters layered ON TOP — the date window for the
 *     builder, the host `globalPayload` for the embed (both already wire-shaped)
 *     — first projected down to the keys THIS widget supports (date keys always
 *     apply). Injected wins on key collision.
 */
export function resolveTileFilters(
  savedFiltersJson: Record<string, unknown> | undefined,
  injectedFilters: ByodFilterMap,
  supportedFilters: string[] | undefined,
): ByodFilterMap {
  return {
    ...convertStructuredFiltersForWire(savedFiltersJson ?? {}),
    ...projectInjectedFilters(injectedFilters, supportedFilters),
  };
}
